module.exports = __webpack_public_path__ + "static/img/logo.86dc3507.png";